import { Alert, AlertTitle, Box } from "@mui/material";
import ActionMenu from "components/ActionMenu";
import { poligonStr2List } from "components/MapPoligons/UtilCalcCordenadas";
import { useFieldValue } from "components/form/input/NestedField";
import ApontamentoAddDialog from "entity/Indicador/components/apontamento/ApontamentoAddDialog";
import ApontamentoDialog from "entity/Indicador/components/apontamento/ApontamentoDialog";
import ApontamentoList from "entity/Indicador/components/apontamento/ApontamentoList";
import getAllTiposIndicador from "entity/TipoIndicador/all";
import { useEffect, useState } from "react";
import { MapaApontamento } from "./MapaApontamento";

/**
 * Todos os tipos de indicador.
 */
function getAllTipos() {
    return getAllTiposIndicador().map((TipoClass) => {
        return {
            id: TipoClass.abbrev,
            label: TipoClass.fullName,
            Class: TipoClass,
        };
    });
}

export default function ApontamentoEditor({ visita, showMap = false }) {
    const { fazenda } = visita
    const [atualVisita] = useFieldValue()
    const allTipos = getAllTipos();
    const [addDialog, setAddDialog] = useState();
    const [editDialog, setEditDialog] = useState();
    const [talhao, setTalhao] = useState();
    // Tipo e apontamento sendo editado.
    const [editTipoClass, setEditTipoClass] = useState();
    const [editIndicadorClass, setEditIndicadorClass] = useState();
    const [editApontamentoIndex, setEditApontamentoIndex] = useState();

    const [outrosPoligonos, setOutrosPoligonos] = useState([])

    useEffect(() => {
        if (fazenda && fazenda.data && fazenda.data.talhoesFazenda) {
            let ou = [];
            fazenda.data.talhoesFazenda.forEach(t => {
                let area = t.area || 0
                if (t.nome !== "") {
                    if (t.areaNoMapStr) {
                        ou.push({
                            title: t.nome,
                            talhao: t,
                            props: { "Área": area },
                            path: poligonStr2List(t.areaNoMapStr)
                        })
                    }
                }
            });
            setOutrosPoligonos(ou)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // O usuário selecionou um tipo de indicador no primeiro menu.
    function selectTipoApontamento(tipo) {
        if (tipo) {
            setEditTipoClass(() => tipo.Class);
            addDialog.setOpen(true);
        }
    }

    // O usuário selecionou um indicador específico no segundo menu.
    function addApontamento(IndicadorClass) {
        if (IndicadorClass) {
            setEditIndicadorClass(() => IndicadorClass);
            setEditApontamentoIndex(null);

            editDialog.setOpen(true);
        }
    }

    // O usuário selecionou um indicador existente para editar.
    function editIndicador(TipoClass, apontamento) {
        setEditTipoClass(() => TipoClass);
        setEditIndicadorClass(() => apontamento.IndicadorClass);
        setEditApontamentoIndex(apontamento.index);

        editDialog.setOpen(true);
    }
    if (!visita.fazenda || !visita.cliente || !atualVisita.safra || !atualVisita.cultura) {
        return (
            <Alert severity="info" sx={{ m: 2 }}>
                <AlertTitle>Campos Necessários</AlertTitle>
                Selecione a <strong>Fazenda</strong>, <strong>Safra</strong> e  <strong>Cultura</strong> na aba dados para adicionar
                apontamentos.
            </Alert>
        );
    }

    return (
        <Box sx={{ height: "100%" }}>
            {!showMap ?
                <>
                    <ActionMenu
                        label="Apontamento"
                        menuItems={allTipos}
                        onClose={selectTipoApontamento}
                        showFilter={false}
                        sx={{ my: 2 }}
                    />

                    {allTipos.map((tipo) => (
                        <ApontamentoList
                            key={tipo.id}
                            TipoClass={tipo.Class}
                            visita={visita}
                            onSelect={(apontamento, index) => editIndicador(tipo.Class, apontamento, index)}
                        />
                    ))}
                </>
                :
                (
                    <MapaApontamento
                        setTalhao={setTalhao}
                        allTipos={allTipos}
                        label={"Apontamento"}
                        outrosPoligonos={outrosPoligonos}
                        selectTipoApontamento={selectTipoApontamento}
                    />
                )
            }


            <ApontamentoAddDialog TipoClass={editTipoClass} setDialog={setAddDialog} onClose={addApontamento} />

            <ApontamentoDialog
                visita={visita}
                talhao={talhao}
                TipoClass={editTipoClass}
                IndicadorClass={editIndicadorClass}
                apontamentoIndex={editApontamentoIndex}
                setDialog={setEditDialog}
            />
        </Box>
    );
}
